module.exports = [
	{
		"_id": "561eb4e2ebd3da83cca919cd",
		"index": 0,
		"guid": "e4a3c415-cc1e-4ea2-ac51-643ab7682749",
		"isActive": false,
		"balance": "$1,973.10",
		"picture": "http://placehold.it/32x32",
		"age": 25,
		"eyeColor": "green",
		"name": "Beth Henderson",
		"gender": "female",
		"company": "COMTRACT",
		"email": "bethhenderson@comtract.com",
		"phone": "+1 (812) 525-3569",
		"address": "557 Hinckley Place, Baker, Rhode Island, 109",
		"score": 7472,
		"money": 3286.94,
		"percent": 0.4786
	},
	{
		"_id": "561eb4e213d9e9e666e19e38",
		"index": 1,
		"guid": "3ccd03d7-a31d-400a-b5df-d330ceb629f0",
		"isActive": true,
		"balance": "$2,865.54",
		"picture": "http://placehold.it/32x32",
		"age": 40,
		"eyeColor": "brown",
		"name": "Dillard Johnson",
		"gender": "male",
		"company": "AQUOAVO",
		"email": "dillardjohnson@aquoavo.com",
		"phone": "+1 (918) 476-3583",
		"address": "566 Summit Street, Alderpoint, Guam, 9601",
		"score": 1858,
		"money": 9013.75,
		"percent": 0.7015
	},
	{
		"_id": "561eb4e26c32747cb4f5a165",
		"index": 2,
		"guid": "0db9f86f-8c8e-498d-880f-7f21448383c7",
		"isActive": true,
		"balance": "$2,982.97",
		"picture": "http://placehold.it/32x32",
		"age": 35,
		"eyeColor": "brown",
		"name": "Marilyn Hayes",
		"gender": "female",
		"company": "ISOSWITCH",
		"email": "marilynhayes@isoswitch.com",
		"phone": "+1 (954) 476-2974",
		"address": "307 Brooklyn Avenue, Roy, Florida, 1662",
		"score": 8629,
		"money": 5762.29,
		"percent": 0.4416
	},
	{
		"_id": "561eb4e2d6337eb4457380c7",
		"index": 3,
		"guid": "141787e1-36b5-4236-8b51-6a6ff081c2f4",
		"isActive": true,
		"balance": "$3,581.89",
		"picture": "http://placehold.it/32x32",
		"age": 25,
		"eyeColor": "blue",
		"name": "Hamilton Merritt",
		"gender": "male",
		"company": "VERBUS",
		"email": "hamiltonmerritt@verbus.com",
		"phone": "+1 (849) 447-3091",
		"address": "243 Remsen Street, Barstow, Arizona, 4191",
		"score": 2847,
		"money": 3278.73,
		"percent": 0.4951
	},
	{
		"_id": "561eb4e204ef3a867a2089bd",
		"index": 4,
		"guid": "34297338-4835-45fd-9738-162e637c30d7",
		"isActive": false,
		"balance": "$3,713.53",
		"picture": "http://placehold.it/32x32",
		"age": 23,
		"eyeColor": "green",
		"name": "Greene Watson",
		"gender": "male",
		"company": "INTERFIND",
		"email": "greenewatson@interfind.com",
		"phone": "+1 (987) 455-2375",
		"address": "687 Tompkins Avenue, Glenville, Virgin Islands, 3661",
		"score": 4882,
		"money": 6089.72,
		"percent": 0.7374
	},
	{
		"_id": "561eb4e2b79c0ce08da5db1b",
		"index": 5,
		"guid": "166ca0b1-54ba-4e0a-afd2-abca0d0a240d",
		"isActive": false,
		"balance": "$1,138.01",
		"picture": "http://placehold.it/32x32",
		"age": 31,
		"eyeColor": "brown",
		"name": "Bryant Irwin",
		"gender": "male",
		"company": "UXMOX",
		"email": "bryantirwin@uxmox.com",
		"phone": "+1 (913) 462-3690",
		"address": "869 Noble Street, Coaldale, North Carolina, 9542",
		"score": 5333,
		"money": 8405.4,
		"percent": 0.9098
	},
	{
		"_id": "561eb4e2e0f524682a1d375c",
		"index": 6,
		"guid": "2c6262c8-1951-491d-9229-5ca9de953e43",
		"isActive": true,
		"balance": "$3,623.61",
		"picture": "http://placehold.it/32x32",
		"age": 38,
		"eyeColor": "brown",
		"name": "Peters Cooper",
		"gender": "male",
		"company": "ZOGAK",
		"email": "peterscooper@zogak.com",
		"phone": "+1 (966) 442-3250",
		"address": "175 Cox Place, Idamay, Nebraska, 1177",
		"score": 4252,
		"money": 2368.27,
		"percent": 0.9168
	},
	{
		"_id": "561eb4e2de4f3e20013e522a",
		"index": 7,
		"guid": "c5368365-ef62-4c62-ba35-e4ed4e34da30",
		"isActive": false,
		"balance": "$1,542.41",
		"picture": "http://placehold.it/32x32",
		"age": 40,
		"eyeColor": "brown",
		"name": "Mercer Mullen",
		"gender": "male",
		"company": "BEZAL",
		"email": "mercermullen@bezal.com",
		"phone": "+1 (915) 436-2751",
		"address": "193 Bushwick Place, Outlook, New Hampshire, 9450",
		"score": 562,
		"money": 8875.18,
		"percent": 0.8606
	},
	{
		"_id": "561eb4e2366bb5718312e0e7",
		"index": 8,
		"guid": "69d9ef15-5d2d-4942-997a-c719a4ac7111",
		"isActive": false,
		"balance": "$3,844.90",
		"picture": "http://placehold.it/32x32",
		"age": 33,
		"eyeColor": "blue",
		"name": "Stark Pace",
		"gender": "male",
		"company": "ONTAGENE",
		"email": "starkpace@ontagene.com",
		"phone": "+1 (907) 493-2544",
		"address": "863 Hawthorne Street, Brooktrails, Texas, 4754",
		"score": 2811,
		"money": 8659.11,
		"percent": 0.3582
	},
	{
		"_id": "561eb4e2db05a1d66070c590",
		"index": 9,
		"guid": "3e56f58c-858c-4c21-a30e-5c58848edbcc",
		"isActive": true,
		"balance": "$3,109.24",
		"picture": "http://placehold.it/32x32",
		"age": 36,
		"eyeColor": "blue",
		"name": "Marsha Mcbride",
		"gender": "female",
		"company": "UNIWORLD",
		"email": "marshamcbride@uniworld.com",
		"phone": "+1 (977) 406-3353",
		"address": "414 Kingsland Avenue, Richmond, Arkansas, 6421",
		"score": 7734,
		"money": 7035.38,
		"percent": 0.9847
	},
	{
		"_id": "561eb4e26eb9d916460c6d6c",
		"index": 10,
		"guid": "0e50995a-7c0b-4abb-b5c3-b6b588b84b2f",
		"isActive": false,
		"balance": "$1,437.12",
		"picture": "http://placehold.it/32x32",
		"age": 22,
		"eyeColor": "green",
		"name": "Aguirre Holloway",
		"gender": "male",
		"company": "GEOFORMA",
		"email": "aguirreholloway@geoforma.com",
		"phone": "+1 (978) 522-2386",
		"address": "693 Melba Court, Harmon, Massachusetts, 7425",
		"score": 4542,
		"money": 302.93,
		"percent": 0.2301
	},
	{
		"_id": "561eb4e29cbaf80c7b03a72a",
		"index": 11,
		"guid": "38cc6a95-d69e-4327-845f-bd2a0704bfbc",
		"isActive": false,
		"balance": "$1,347.80",
		"picture": "http://placehold.it/32x32",
		"age": 21,
		"eyeColor": "blue",
		"name": "Hale Baldwin",
		"gender": "male",
		"company": "EXOSPACE",
		"email": "halebaldwin@exospace.com",
		"phone": "+1 (831) 427-2932",
		"address": "956 Ferry Place, Evergreen, North Dakota, 6906",
		"score": 6118,
		"money": 1384.88,
		"percent": 0.8457
	},
	{
		"_id": "561eb4e21ea43ea747b5e496",
		"index": 12,
		"guid": "92801423-352a-489e-a220-c234bcef9628",
		"isActive": true,
		"balance": "$1,949.50",
		"picture": "http://placehold.it/32x32",
		"age": 34,
		"eyeColor": "blue",
		"name": "Bean Rollins",
		"gender": "male",
		"company": "AUTOGRATE",
		"email": "beanrollins@autograte.com",
		"phone": "+1 (973) 559-2415",
		"address": "882 Willow Place, Cartwright, Alabama, 7654",
		"score": 8629,
		"money": 6422.5,
		"percent": 0.8685
	},
	{
		"_id": "561eb4e29088d22b28de2a26",
		"index": 13,
		"guid": "ec60989b-5113-4e0e-96b6-df4e6863d708",
		"isActive": false,
		"balance": "$3,349.11",
		"picture": "http://placehold.it/32x32",
		"age": 23,
		"eyeColor": "green",
		"name": "Jeanie Santos",
		"gender": "female",
		"company": "PAWNAGRA",
		"email": "jeaniesantos@pawnagra.com",
		"phone": "+1 (990) 554-2930",
		"address": "929 Auburn Place, Shrewsbury, New York, 4348",
		"score": 5144,
		"money": 1026.38,
		"percent": 0.5715
	},
	{
		"_id": "561eb4e27da66d878b1ee62e",
		"index": 14,
		"guid": "f77bf3e8-7e8d-49c0-a8f3-01bb94915bd0",
		"isActive": true,
		"balance": "$3,766.02",
		"picture": "http://placehold.it/32x32",
		"age": 37,
		"eyeColor": "green",
		"name": "Avery Holder",
		"gender": "male",
		"company": "EZENT",
		"email": "averyholder@ezent.com",
		"phone": "+1 (912) 474-3863",
		"address": "553 Olive Street, Dupuyer, Oklahoma, 7885",
		"score": 4146,
		"money": 2176.13,
		"percent": 0.5429
	},
	{
		"_id": "561eb4e224098ec7dc2293a6",
		"index": 15,
		"guid": "5c22b549-5af0-45d0-8e06-981854ec9dfa",
		"isActive": true,
		"balance": "$2,742.83",
		"picture": "http://placehold.it/32x32",
		"age": 28,
		"eyeColor": "brown",
		"name": "Long Le",
		"gender": "male",
		"company": "IRACK",
		"email": "longle@irack.com",
		"phone": "+1 (841) 498-2593",
		"address": "359 Grove Street, Finderne, Virginia, 7757",
		"score": 7819,
		"money": 4300.1,
		"percent": 0.2581
	},
	{
		"_id": "561eb4e2c6f3bffb70608207",
		"index": 16,
		"guid": "abb925ad-6119-40a6-b9b5-954e1bfd92f7",
		"isActive": false,
		"balance": "$3,480.85",
		"picture": "http://placehold.it/32x32",
		"age": 34,
		"eyeColor": "blue",
		"name": "Roy Davidson",
		"gender": "male",
		"company": "ISOPLEX",
		"email": "roydavidson@isoplex.com",
		"phone": "+1 (985) 528-2461",
		"address": "756 Wilson Street, Calvary, Minnesota, 7315",
		"score": 4640,
		"money": 2019.3,
		"percent": 0.7373
	},
	{
		"_id": "561eb4e28af28c8a6e892264",
		"index": 17,
		"guid": "52cdec5e-9b16-4efd-91db-1da7743d96d3",
		"isActive": false,
		"balance": "$2,765.48",
		"picture": "http://placehold.it/32x32",
		"age": 28,
		"eyeColor": "green",
		"name": "Stacey Sawyer",
		"gender": "female",
		"company": "NAMEGEN",
		"email": "staceysawyer@namegen.com",
		"phone": "+1 (922) 483-3580",
		"address": "228 Bartlett Street, Limestone, Wisconsin, 1843",
		"score": 521,
		"money": 1197.02,
		"percent": 0.0239
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./example/data.json
 ** module id = 57
 ** module chunks = 0
 **/